//@ts-check
import queryString from 'query-string';
/**
 * @type {import("./types").stringifySearchParamsType}
 */

export default function stringifySearchParams(searchParams, options) {
  return queryString.stringify(searchParams, options);
}